import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './EntryPageTemplate.module.scss';

function EntryPageTemplate(props) {
    const { contentToRender } = props;

    return (
        <Fragment>
            <div id="entryPageTemplate" className={styles.entryPageTemplate}>
                <div id="entryPageTemplateContent" className={styles.entryPageTemplateContent}>
                    <div
                        id="entryPageContentContainer"
                        className={styles.entryPageContentContainer}
                    >
                        {contentToRender}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

EntryPageTemplate.propTypes = {
    // applicationName: PropTypes.string.isRequired,
    // applicationLogo: PropTypes.string.isRequired,
    contentToRender: PropTypes.shape({}).isRequired
};

export default EntryPageTemplate;
